import { z } from "zod";
const WebTriggerEditorMessageHoverElement = z.object({
    name: z.literal("hover-element"),
    elementSelector: z.string().nullable()
});
const WebTriggerEditorMessageHoverElementClick = z.object({
    name: z.literal("hover-element-click"),
    elementSelector: z.string().nullable()
});
const WebTriggerEditorMessageURLDidChange = z.object({
    name: z.literal("url-did-change"),
    url: z.string()
});
export const WebTriggerEditorMessageSchema = z.discriminatedUnion("name", [
    WebTriggerEditorMessageHoverElement,
    WebTriggerEditorMessageHoverElementClick,
    WebTriggerEditorMessageURLDidChange
]);
export const WrappedWebTriggerEditorMessageSchema = z.object({
    _type: z.literal("sw-web-trigger-editor"),
    version: z.literal(1),
    events: z.array(WebTriggerEditorMessageSchema)
});
